import { Component, OnInit } from '@angular/core';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { CryptoVaultService } from 'src/app/shared/services/external/crypto-vault/crypto-vault.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { CHANNEL as CHANNEL_CONSTANS } from '../../../../shared/constants/channel.constants';
@Component({
  selector: 'app-request-loan',
  templateUrl: './request-loan.component.html',
  styleUrls: ['./request-loan.component.scss'],
})
export class RequestLoanComponent implements OnInit {
  data = this.abreCuentasService
    .getProductsSelects()
    .find((s: any) => s.flow === 'freeInvestment2' || 'loan').name;

  isBtnDisabled = true;
  selectedData: any;
  listRequestLoan: any = this.validateProduct();

  constructor(
    private headerService: HeaderService,
    public copyService: CopyService,
    private bitacoraService: BitacoraService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private requestService: RequestService,
    private cipherService: CryptoVaultService,
  ) {
    this.headerService.show(true, true, true);
  }

  ngOnInit() {
    if (this.abreCuentasService.getPostlogin()) {
      this.clientProduct();
    }
    this.selectedData = this.abreCuentasService.getRequestLoanSelected();
    if (this.abreCuentasService.getRequestLoanSelected() && this.abreCuentasService.getRequestLoanSelected().elementId) {
      this.listRequestLoan = this.listRequestLoan === undefined ? [] : this.listRequestLoan.map((item: any) => ({
        description: item.description,
        elementId: item.elementId,
        checked: this.selectedData.elementId === item.elementId,
      }));
      console.log(this.listRequestLoan);
      this.isBtnDisabled = false;
    }

  }

  validateProduct() {
    const products = [{
      description:
        this.data + ' ' + this.copyService.copies.request_loan_radio1,
      elementId: '01',
      checked: false,
    }];
    if (this.abreCuentasService.haveLoan) {
      products.push({
        description:
          this.data + ' ' + this.copyService.copies.request_loan_radio2,
        elementId: '02',
        checked: false,
      });
    }
    return products;
  }

  selectRequestLoan(event: any) {
    this.isBtnDisabled = false;
    this.selectedData = event;
  }

  async clientProduct() {
    await this.requestService.clientProduct().then((res: any) => {
      res.body.data.forEach(record => {
        console.log(this.cipherService.decrypt(record.product_type));
        console.log(this.cipherService.decrypt(record.product_number));
        console.log(this.cipherService.decrypt(record.product_sub_type));
      });
    });
  }

  next() {
    this.abreCuentasService.setProductDestinationType(this.selectedData.elementId === '01' ? '00' : undefined);
    this.abreCuentasService.setRequestLoanSelected(this.selectedData);
    if (this.selectedData.elementId === '01') {
      this.bitacoraService.saveDataInBitacora('Payroll_without_Purchase');
      this.navigationService.nextStep('200');
    } else {
      this.bitacoraService.saveDataInBitacora('Payroll_with_Purchase');
      this.abreCuentasService.chanelid === CHANNEL_CONSTANS.PORTALO.CODE ?
        this.navigationService.nextStep('203') : this.abreCuentasService.getPostlogin() ?
          this.navigationService.nextStep('202') : this.navigationService.nextStep('201');
    }
  }
}
